import React, { useState, useEffect } from 'react';
import { Send, X } from 'lucide-react';
import { sendMessage, subscribeToMessages } from '../firebase/messages';

const ChatWindow = ({ currentUser, chatUser, onClose }) => {
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');

  useEffect(() => {
    if (!currentUser || !chatUser) return;

    // Subscribe to messages
    const unsubscribe = subscribeToMessages(
      currentUser.id,
      chatUser.id,
      setMessages
    );

    return () => unsubscribe();
  }, [currentUser, chatUser]);

  const handleSend = async () => {
    if (!newMessage.trim()) return;

    await sendMessage(currentUser.id, chatUser.id, newMessage);
    setNewMessage('');
  };

  return (
    <div className="fixed bottom-4 right-4 w-96 h-[500px] bg-white rounded-2xl shadow-2xl flex flex-col">
      {/* Header */}
      <div className="bg-red-600 text-white p-4 rounded-t-2xl flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <img src={chatUser.avatar} alt={chatUser.name} className="w-10 h-10 rounded-full" />
          <div>
            <h3 className="font-semibold">{chatUser.name}</h3>
            <p className="text-xs text-red-100">{chatUser.location}</p>
          </div>
        </div>
        <button onClick={onClose} className="hover:bg-red-700 p-1 rounded">
          <X className="w-5 h-5" />
        </button>
      </div>

      {/* Messages */}
      <div className="flex-1 overflow-y-auto p-4 space-y-3">
        {messages.map((msg) => (
          <div
            key={msg.id}
            className={`flex ${msg.senderId === currentUser.id ? 'justify-end' : 'justify-start'}`}
          >
            <div
              className={`max-w-[70%] rounded-2xl px-4 py-2 ${
                msg.senderId === currentUser.id
                  ? 'bg-red-600 text-white'
                  : 'bg-gray-100 text-gray-900'
              }`}
            >
              <p>{msg.text}</p>
              <p className={`text-xs mt-1 ${
                msg.senderId === currentUser.id ? 'text-red-100' : 'text-gray-500'
              }`}>
                {msg.timestamp?.toDate().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* Input */}
      <div className="p-4 border-t flex space-x-2">
        <input
          type="text"
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          onKeyPress={(e) => e.key === 'Enter' && handleSend()}
          placeholder="Type a message..."
          className="flex-1 px-4 py-2 border rounded-full focus:outline-none focus:ring-2 focus:ring-red-500"
        />
        <button
          onClick={handleSend}
          className="bg-red-600 text-white p-2 rounded-full hover:bg-red-700"
        >
          <Send className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default ChatWindow;